/* global fetch */
import _ from 'lodash'
import url from 'url'
import * as CONTENT_TYPE from 'common/constant/content-type'
import * as HTTP_METHOD from 'common/constant/http-method'

const API_URL = process.env.API_URL

const createFormattedUrl = (apiUrl, query) => {
  const parsedAPIUrl = url.parse(API_URL + apiUrl) // eslint-disable-line

  const formattedUrl = url.format({
    ...parsedAPIUrl,
    query: _.pickBy(query, _.identity)
  })
  return formattedUrl
}

// eslint-disable-next-line complexity
const parseResponse = async (response, returnHeaders) => {
  const json = await response.json()
  if (response.ok) {
    if (returnHeaders) {
      return response
    }

    return json
  } else {
    throw new Error(json.error)
  }
}

export const postJson = async (inputUrl, headers = {}, body = {}, returnHeaders = false) => {
  const response = await fetch(createFormattedUrl(inputUrl, null), {
    body: typeof body === 'string' ? body : JSON.stringify(body),
    credentials: HTTP_METHOD.CREDENTIALS_INCLUDE,
    headers: {
      [CONTENT_TYPE.CONTENT_TYPE_HEADER]: CONTENT_TYPE.JSON,
      ...headers
    },
    method: HTTP_METHOD.POST
  })
  const parsed = await parseResponse(response, returnHeaders)
  return parsed
}

export const postFile = async (inputUrl, headers = {}, body = {}, returnHeaders = false) => {
  const response = await fetch(inputUrl, {
    body,
    credentials: HTTP_METHOD.CREDENTIALS_INCLUDE,
    headers,
    method: HTTP_METHOD.POST
  })

  return response
}

export const getJson = async (inputUrl, headers = {}, queryStrings = {}, returnStatus = false) => {
  const response = await fetch(createFormattedUrl(inputUrl, queryStrings), {
    credentials: HTTP_METHOD.CREDENTIALS_INCLUDE,
    headers: {
      [CONTENT_TYPE.CONTENT_TYPE_HEADER]: CONTENT_TYPE.JSON,
      ...headers
    },
    method: HTTP_METHOD.GET
  })

  const parsed = await parseResponse(response, false)
  return parsed
}

export const putFile = async (inputUrl, file, contentType, headers = {}) => {
  const response = await fetch(inputUrl, {
    body: file,
    headers: {
      [CONTENT_TYPE.CONTENT_TYPE_HEADER]: contentType,
      ...headers
    },
    method: HTTP_METHOD.PUT
  })

  return response
}

export const getFile = async (inputUrl) => {
  const response = await fetch(inputUrl, {
    method: HTTP_METHOD.GET
  })

  return response.text()
}

export const deleteJson = async (inputUrl, headers = {}, queryStrings = {}) => {
  const response = await fetch(createFormattedUrl(inputUrl, queryStrings), {
    credentials: HTTP_METHOD.CREDENTIALS_INCLUDE,
    headers: {
      [CONTENT_TYPE.CONTENT_TYPE_HEADER]: CONTENT_TYPE,
      ...headers
    },
    method: HTTP_METHOD.DELETE
  })

  const parsed = await parseResponse(response, false)

  return parsed
}
